module.exports = __webpack_public_path__ + "assets/img/checkbox-v.db2408c4.svg";